import { render } from "./SelectCustomerView.vue?vue&type=template&id=717dbf1c"
import script from "./SelectCustomerView.vue?vue&type=script&lang=js"
export * from "./SelectCustomerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__